import React, { Component } from "react";
import PhotoContextProvider from "./context/PhotoContext";
import Wizard from "./components/Wizard";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { lightBlue, blue, cyan, lightGreen } from "@mui/material/colors";

// create theme with button labels not Uppercase
const wizardButtonTheme = createTheme({
  palette: {
    primary: lightBlue,
    secondary: cyan,
  },
  components: {

    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: 'unset',
          outline: 'unset',
          margin: '1em',
        },

        label: {
          textTransform: 'none',
          fontSize: 'medium',
        }
      }

    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          marginTop: '30px',
        }
      }
    },
    // NEVE TEMPLATE CONFLICT FIXES
    MuiStepButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#fff",
            color: "#000",
          }
        }
      }
    },

    MuiCardActionArea: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#fff",
            color: "#000",
          }
        }
      }
    },


    MuiTextField: {
      styleOverrides: {
        root: {
          margin: '1em',
        }
      }
    },

    MuiInput: {
      styleOverrides: {
        root: {
          "& input": {
            border: '0px',
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          margin: '0px',
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          width: '1.5em',
          height: '1.5em',
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        }
      }
    },
    // END -- NEVE TEMPLATE CONFLICT FIXES
  },
  spacing: '30',
});



class App extends Component {
  // Prevent page reload, clear input, set URL and push history on submit
  handleSubmit = (e, history, searchInput) => {
    e.preventDefault();
    e.currentTarget.reset();
    let url = `/search/${searchInput}`;
    history.push(url);
  };




  render() {
    return (

      <ThemeProvider theme={wizardButtonTheme}>
        <Wizard />
      </ThemeProvider>
    );
  }
}

export default App;
